import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
} from "@mui/material";

const EMPTY_FORM = {
  breederCode: "",
  description: "",
  chickWeight: "",
  quantity: "",
  parentAge: "",
  batchDate: "",
  hatcherNo: "",
  setterNo: "",
  deformities: "",
};

function DocDetailsDialog({ open, onClose, onSave, initial }) {
  const [form, setForm] = useState(() => ({ ...EMPTY_FORM }));

  useEffect(() => {
    if (!open) return;
    if (initial && Object.keys(initial).length > 0) {
      setForm({ ...EMPTY_FORM, ...initial });
    } else {
      setForm({ ...EMPTY_FORM });
    }
  }, [open, initial]);

  const handleChange = (field) => (e) => setForm({ ...form, [field]: e.target.value });
  const handleSave = () => onSave(form);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>DOC Details</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mt={0.5}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Breeder code"
              value={form.breederCode}
              onChange={handleChange("breederCode")}
              fullWidth
              size="medium"
              InputLabelProps={{ sx: { fontSize: "0.95rem" } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Descript."
              value={form.description}
              onChange={handleChange("description")}
              fullWidth
              size="medium"
              InputLabelProps={{ sx: { fontSize: "0.95rem" } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Chick weight"
              value={form.chickWeight}
              onChange={handleChange("chickWeight")}
              fullWidth
              size="medium"
              InputLabelProps={{ sx: { fontSize: "0.95rem" } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Quantity"
              value={form.quantity}
              onChange={handleChange("quantity")}
              fullWidth
              size="medium"
              InputLabelProps={{ sx: { fontSize: "0.95rem" } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Parent age (wk)"
              value={form.parentAge}
              onChange={handleChange("parentAge")}
              fullWidth
              size="medium"
              InputLabelProps={{ sx: { fontSize: "0.95rem" } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Date"
              type="datetime-local"
              value={form.batchDate}
              onChange={handleChange("batchDate")}
              fullWidth
              size="medium"
              InputLabelProps={{ shrink: true, sx: { fontSize: "0.95rem" } }}
              inputProps={{ step: 60 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Hatcher no."
              value={form.hatcherNo}
              onChange={handleChange("hatcherNo")}
              fullWidth
              size="medium"
              InputLabelProps={{ sx: { fontSize: "0.95rem" } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Setter no."
              value={form.setterNo}
              onChange={handleChange("setterNo")}
              fullWidth
              size="medium"
              InputLabelProps={{ sx: { fontSize: "0.95rem" } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="No. of Deformities"
              value={form.deformities}
              onChange={handleChange("deformities")}
              fullWidth
              size="medium"
              InputLabelProps={{ sx: { fontSize: "0.95rem" } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} sx={{ color: "#fff" }}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DocDetailsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  initial: PropTypes.object,
};

export default DocDetailsDialog;
